
import { ABOUTBANNER_GET_LIST,ABOUTBANNER_GET_LIST_SUCCESS,ABOUTBANNER_GET_LIST_ERROR } from "../../../redux/contants";

const INIT_STATE = {
    getAboutBannerList: [],
    loading: false,
    error: '',
    messages: ''
};
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case ABOUTBANNER_GET_LIST:
                // alert(action.type)
                // alert(action.data)
                return { ...state, loading: true, error: '' };
            
        case ABOUTBANNER_GET_LIST_SUCCESS:
                console.log('ABOUTBANNER_GET_LIST_SUCCESS===',action);
                return {
                    ...state,
                    loading: false,
                    getAboutBannerList: action.data,
                    error: '',
                    messages: ''
                };
        case ABOUTBANNER_GET_LIST_ERROR:
                return {
                    ...state,
                    loading: false,
                    getAboutBannerList: [],
                    error: action.error,
                    messages: ''
                };
        default:
            return { ...state };
    }
};
